/**
 * Dies ist eine Model für die Darstellung eines des Baumes.
 *
 * @author femu
 */
export class Tree {
    public id: string;
    public name: string;
    public hasChildren: boolean;
    public children: Tree[] = [];
    public hasAccess: boolean;

    // Die Anzeige der Icons wurde bisher komplett durch hasAccess gesteuert.
    // Um einen "read-only" Modus zu ermöglichen und trotzdem abwärtskompatibel zu bleiben,
    // ermöglichen die folgene Felder optional das einzelne Ausblenden der Buttons.
    public hideEdit?: boolean;
    public hideAdd?: boolean;

    public expanded: boolean;
    public padding;
    public style: object;
}
